import React, { Component } from 'react';

/* Images */
import baseImg from '../../assets/gerald1.jpg';
import geraldSilo from '../../assets/silo/gerald.png';
import astroSilo from '../../assets/silo/astro.png';
import wakandaSilo from '../../assets/silo/wakanda.png';
import tianaSilo from '../../assets/silo/tiana.png';
import fillmoreSilo from '../../assets/silo/fillmore.png';
import susieSilo from '../../assets/silo/susie.png';

var phraseInfo = null, phraseInfo2 = [], writerStatus = false;

class Gerald extends Component{
    constructor(props) {
        super(props);
        this.state = {
            name:"",
            selectedPhrase:[],
            prePause:700, typePause:50,
            phraseSz:{current:0, final:1 },
            scrollPos: 0,
            pages: [
                { name:"gerald", img: geraldSilo, description: "I'm here just as a guild to help navigate you through it all." },
                { name:"susie", img: susieSilo, description: "Use Susie's eye for detail for an array of visual tools." },
                { name:"wakanda", img: wakandaSilo, description: "Finance's are important so we are here to help you keep track of budgeting." },
                { name:"tiana", img: tianaSilo, description: "There are alot of good foods out here, let me help give you dinner ideas & save your favorites." },
                { name:"fillmore", img: fillmoreSilo, description: "Keeping track of locations and directions is very important. 'One more thing'. That chicken as dry, Real Dry'" },
                { name:"astro", img: astroSilo, description: "Helping keep a watch over whats going on in and around the house." }
            ]
        }
        /* Refs */
        this.pageRef = React.createRef();

        this.buildPhrase = this.buildPhrase.bind(this);
        this.stopWriter = this.stopWriter.bind(this);
        this.phraseWriter = this.phraseWriter.bind(this);
        this.typePhrase = this.typePhrase.bind(this);
        this.displayScroll = this.displayScroll.bind(this);
        this.moveCtrl = this.moveCtrl.bind(this);
    }

    buildPhrase(){
        var self = this;
        try {
            const phraseRunTime = 15 * 60000;
            var user = this.props.checkUser(false,true);

            if(user) {
                var phrases = [
                    { text:"Welcome " , class:"txt-title"},
                    { text: user.name, class:"txt-title name"},
                    { text: "I'm Naratif La, the story teller I can help keep you informed, connected, & keep an eye on whats going on here at home", class:"txt-info"}
                ];

                //Check Date
                if(this.props.getInit() || (user.loginDt + phraseRunTime) < (new Date()).getTime()){
                    this.setState({ selectedPhrase: phrases });
                }
                else {                
                    this.phraseWriter(phrases, function(ret){
                        self.props.setInit();
                    });
                }
            }
        }
        catch(ex){
            console.log("[Error] building phrase: ",ex);
        }
    }

    stopWriter(){
        try {
            clearTimeout(phraseInfo);
        }
        catch(ex){
            console.log(" [ERROR] Stopping Writer: ",ex);
        }
    }

    phraseWriter(phrase, callback){
        var self = this;
        try {
            writerStatus = false;
            /* Type Text */                        
            self.setState({ selectedPhrase: [] }, () => {
                phraseInfo = setTimeout(function () {
                    self.typePhrase(phrase, function(){
                        setTimeout(function () {callback();}, self.state.readPause);
                    });
                }, self.state.prePause);
            });   
        }
        catch(ex){
            console.log("Error with phrasewriter: ",ex);
        }
    }

    typePhrase(phrase, callback){
        var self = this;
        try {
            let k = 0; 
            let textSz = { current:0, final:0};
            phrase.map(function(item){ textSz.final = textSz.final + item.text.length; return item; });
            self.setState({ phraseSz: textSz });

            for(var i=0; i < phrase.length; i++){
                let i2 = i;
                for(var j =0; j < phrase[i].text.length; j++){
                    let j2 = j;
                    phraseInfo2.push(setTimeout(function () {
                        var tmpPhraseList = self.state.selectedPhrase;
                        if(tmpPhraseList.length < i2+1 ){
                            tmpPhraseList.push({text:"", class:phrase[i2].class});
                        }
                        tmpPhraseList[i2].text = tmpPhraseList[i2].text + phrase[i2].text[j2];
                        
                        textSz.current++;
                        self.setState({ selectedPhrase: tmpPhraseList, phraseSz: textSz}, () =>{
                            if((i2+1) >= phrase.length && (j2+1) >= phrase[i2].text.length) { callback(); }
                        });
                    }, self.state.typePause * (k+1)));
                    k++;
                }
            }
        }
        catch(ex){
            console.log("[ERROR] Typing Phrase: ",ex);
        }
    }

    displayScroll(dir){
        var ret = false;
        try {  
            if(this.pageRef && this.pageRef.current) {
                if(dir == -1) {
                    ret = (this.state.scrollPos > 0);
                }                  
                else {
                    ret = (this.pageRef.current.clientWidth + this.state.scrollPos < this.pageRef.current.scrollWidth);
                }
            }
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }

        return ret;
    }

    moveCtrl(dir){
        var scrollInt = 260;
        try {  
            if(this.pageRef && this.pageRef.current) {
                var tmpPos = this.pageRef.current.scrollLeft + (scrollInt * dir);
                this.pageRef.current.scrollLeft = tmpPos;
                this.setState({ scrollPos: tmpPos });     
            }           
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }
    }

    componentDidMount() { 
        try {              
            this.buildPhrase();                        
        }
        catch(ex){
            console.log("[Error]: ",ex);
        }
    }

    componentWillUnmount() {
        this.stopWriter();
    }

    render(){   
        return(
            <div className="page-container gerald-page">
                <div className="page-panel title">
                    <div className="title-content">
                        <div className="writer-phrase">
                            {this.state.selectedPhrase.map((item,i) =>
                                <div className={"line-item "+item.class} key={i}>{item.text}</div>
                            )}
                        </div>
                    </div>
                    <img className="title-img" src={baseImg} />
                </div>
                
                <div className="user-info-ctrl">
                    <div className={"ctrl" + (this.displayScroll(-1) ? "" : " disable")} onClick={() => this.moveCtrl(-1)}><i className="fas fa-angle-left" /></div>
                    <div className={"ctrl" + (this.displayScroll(1) ? "" : " disable")} onClick={() => this.moveCtrl(1)}><i className="fas fa-angle-right" /></div>
                </div>

                <div className="user-info-container" ref={this.pageRef}>
                    {this.state.pages.map((page,i) =>
                        <div className="user-info" key={i}>
                            <div className={"user-silo " + page.name}> 
                                <img src={page.img} alt={page.name + " silo"}/>
                            </div>
                            <div className="user-description">{page.description}</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Gerald;